import React from 'react';
import { useTranslation } from 'react-i18next';
import { useIsMobile } from 'Hooks';
import { Icon } from 'Components';
import { joinItems } from 'PhishingManager/utils';
import styles from './TemplateListCard.module.scss';

export interface TemplateListItemData {
  id: number | string;
  title: string;
  languagesCount?: number;
  categories?: string[] | string;
  difficulty?: string;
  img_path?: string;
}

interface TemplateListCardProps {
  data: TemplateListItemData;
  onReview: (id: number | string) => void;
  onEdit?: (id: number | string) => void;
  isSuperAdmin?: boolean;
}

const FALLBACK_THUMBNAIL = 'https://placehold.co/24x24';

export const TemplateListCard: React.FC<TemplateListCardProps> = ({
  data,
  onReview,
  onEdit,
  isSuperAdmin = true
}) => {
  const { t } = useTranslation();
  const isMobile = useIsMobile();

  const handleReviewClick = () => {
    onReview(data.id);
  };

  const handleEditClick = () => {
    if (onEdit) {
      onEdit(data.id);
    } else {
      onReview(data.id);
    }
  };

  const categoryText = joinItems(data.categories);

  return (
    <div className={styles.cardContainer}>
      <div className={styles.thumbnailWrapper}>
        <img
          src={data.img_path || FALLBACK_THUMBNAIL}
          alt={data.title}
          className={styles.thumbnailImage}
        />
      </div>

      <div className={styles.contentWrapper}>
        <div className={styles.titleRow}>
          <span className={styles.templateTitle} title={data.title}>
            {data.title}
          </span>
        </div>
        <div className={styles.languageCount} title={categoryText}>
          {categoryText}
        </div>
      </div>

      <div className={styles.actionsWrapper}>
        <button
          type="button"
          onClick={handleReviewClick}
          className={styles.detailsButton}
        >
          <span className={styles.detailsButtonText}>
            {t('phishingManager.campaignSetup.step1.templateCard.select')}
          </span>
        </button>

        {isSuperAdmin && !isMobile && (
          <div className={styles.adminActionGroup}>
            <div className={styles.divider} />
            <button
              type="button"
              onClick={handleEditClick}
              className={styles.editButton}
              title={t('phishingTemplateManager.prefilledForm.editTemplateTitle')}
            >
              <Icon type="editPencil" />
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default TemplateListCard;